import * as React from "react";
import { StaticImage } from "gatsby-plugin-image";
import Link from "../link/link";
import styled from "styled-components";
import { DefaultFontStack } from "../typography/typography";

const Root = styled.div`
  display: grid;
`;

const Content = styled.div`
  display: grid;

  grid-column-start: 1;
  grid-row-start: 1;
  position: relative;
  z-index: 5;

  @media (min-width: 1093px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Left = styled.div`
  padding: 48px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Right = styled.div`
  display: none;
  place-items: end;

  @media (min-width: 1093px) {
    display: grid;
  }
`;

const Note = styled.div`
  ${DefaultFontStack}
  background-color: rgb(20 3 3 / 60%);
  width: 100%;
  padding: 5px 0px 5px 30px;
  color: white;
  font-size: 12px;
  max-width: 100%;
  box-sizing: border-box;
`;

const Heading1 = styled.p`
  all: unset;
  ${DefaultFontStack}
  font-size: 32px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.highEmphasis};
  display: block;
  span {
    display: block;
  }
`;

const Heading2 = styled.p`
  all: unset;
  display: block;
  ${DefaultFontStack}
  font-size: 17px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.highEmphasis};
  letter-spacing: 0.5px;
  line-height: 29px;
`;

const CTAContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;

  @media (min-width: 1093px) {
    flex-direction: row;
  }
`;

const PrimaryCTA = styled(Link)`
  all: unset;
  background-color: rgb(16, 112, 192);
  padding: 10px 12px;
  font-family: Arial;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 1.5px;
  line-height: 20px;
  box-shadow: rgba(0, 0, 0, 0.32) 0px 0px 4px;
  color: white;
  border-radius: 40px;
  text-align: center;
  width: fit-content;
  user-select: none;
  cursor: pointer;
`;

const SecondaryCTA = styled(Link)`
  all: unset;
  padding: 7px 12px;
  ${DefaultFontStack}
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.highEmphasis};
  border: 1px solid rgb(128, 128, 128);
  text-align: center;
  border-radius: 40px;
  line-height: 25px;
  width: fit-content;
  user-select: none;
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  grid-column-start: 1;
  grid-row-start: 1;
  display: none;

  @media (min-width: 1093px) {
    display: block;
  }
`;

const MobileFooter = styled.p`
  ${DefaultFontStack}
  color: rgb(153, 153, 153);
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  margin: 0px;

  @media (min-width: 1093px) {
    display: none;
  }
`;

const Bottom = styled.div`
  @media (min-width: 1093px) {
    display: none;
  }
`;

function OEEHomePageHero() {
  return (
    <Root>
      <Content>
        <Left>
          <Heading1>
            <span>Free Resources </span>& Fresh Perspectives on OEE
          </Heading1>
          <Heading2>
            Brought to you by Vorne. We help world-leading manufacturers
            increase manufacturing productivity, cut costs, and reduce downtime.
            We've curated FREE top tools, tips, and resources so you can
            experience production efficiencies like never before.
          </Heading2>
          <CTAContainer>
            <PrimaryCTA url="https://www.vorne.com/">
              Measure & Improve Your OEE Score with Vorne
            </PrimaryCTA>
            <SecondaryCTA url="/oee-topics-overview/">
              Explore all OEE Topics
            </SecondaryCTA>
          </CTAContainer>
        </Left>
        <Right>
          <Note>
            Introducing Vorne XL: a fully integrated IoT device that monitors
            production, alerts operators in real-time via visual scoreboard, and
            informs managers and supervisors through a powerful reporting suite.
          </Note>
        </Right>
        <Bottom>
          <StaticImage
            src="../../assets/images/oee-hero-homepage-mobile.jpeg"
            alt="Background Image"
            layout="fullWidth"
          />
          <MobileFooter>
            Introducing Vorne XL: a fully integrated IoT device that monitors
            production, alerts operators in real-time via visual scoreboard, and
            informs managers and supervisors through a powerful reporting suite.
          </MobileFooter>
        </Bottom>
      </Content>
      <ImageWrapper>
        <StaticImage
          src="../../assets/images/oee-hero-homepage.jpg"
          alt="Background Image"
        />
      </ImageWrapper>
    </Root>
  );
}

export default OEEHomePageHero;
